export const scoreBadgeColors: Record<number, [string, string]> = {
  1: ["border-red-300 bg-red-200 text-red-800", "hover:bg-red-300"],
  2: ["border-red-200 bg-red-100 text-red-700", "hover:bg-red-200"],
  3: ["border-zinc-200 bg-zinc-100 text-zinc-600", "hover:bg-zinc-200"],
  4: [
    "border-emerald-200 bg-emerald-100 text-emerald-700",
    "hover:bg-emerald-200",
  ],
  5: [
    "border-emerald-300 bg-emerald-200 text-emerald-800",
    "hover:bg-emerald-300",
  ],
  0: ["bg-white border border-zinc-300", "hover:bg-zinc-100"],
};
